import type { Observation, Reference } from '@medplum/fhirtypes'
import { formatDate } from '@seen/core/dates'
import { ExtendedObservation } from '@seen/core/models/observation'
import { IconFlask } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useRead } from '#src/hooks/useRead.ts'

export function ObservationOption({
  observation,
}: {
  observation: Reference<Observation>
}): JSX.Element {
  const { data: obs } = useRead(ExtendedObservation, observation)
  return (
    <div className="flex items-center gap-2">
      <div className="p-0.5">
        <IconFlask className="size-4 shrink-0" />
      </div>
      <span>
        {obs?.display}
        {obs && (
          <span className="text-muted-foreground">
            : {obs.valueDisplay ?? ''}
            {obs.effectiveDateTime
              ? ` · ${formatDate(obs.effectiveDateTime)}`
              : ''}
          </span>
        )}
      </span>
    </div>
  )
}
